module.exports = __webpack_public_path__ + "static/img/grid-img@w.0acc6a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgchem/grid-img@w.png
// module id = n7qg
// module chunks = 0